import { Component, Input } from '@angular/core';

export enum WidgetCassaType {
  fondo = "fondo",
  //entrate = "entrate",
  uscite = "uscite",
  denaroRitrovato = "denaroRitrovato"
}

interface IWidgetCassa {
  class: string;
  icon: string;
  label: string;
}

@Component({
  selector: 'ser-widget-cassa',
  templateUrl: './widget-cassa.component.html',
  styleUrl: './widget-cassa.component.scss'
})
export class WidgetCassaComponent {

  @Input() type: WidgetCassaType = WidgetCassaType.fondo;
  @Input() miniMode: boolean = false;
  @Input() value: number;

  styles: { [key in WidgetCassaType] : IWidgetCassa } = {
    fondo: { class: 'bg-primary', icon:'fa-piggy-bank', label: 'fondo'  },
    //entrate: { class: 'bg-success', icon:'fa-sign-in-alt', label: 'entrate'  },
    uscite: { class: 'bg-danger', icon:'fa-sign-out-alt', label: 'uscite'  },
    denaroRitrovato: { class: 'bg-info', icon:'fa-coins', label: 'denaroRitrovato' }
  }

}
